import { deleteMemory } from "@/helpers/apis";
import { Popconfirm } from '@altimateai/lego'
import { Button, toast } from "@altimateai/lego";
import { IconTrash } from "@tabler/icons-react";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAppState } from "@/modules/app/useAppContext";
import { Memory } from "./types";

const DeleteMemoryButton = ({ memory }: { memory: Memory }) => {
  const { loggedinUser: currentUser } = useAppState();
  const queryClient = useQueryClient();
  const deleteMutation = useMutation({
    mutationFn: deleteMemory,
    onSuccess: () => {
      toast({ title: "Memory deleted successfully", variant: "default" });
      queryClient.invalidateQueries({ queryKey: ["memories"] });
    },
    onError: error => {
      toast({
        title: "Failed to delete memory",
        variant: "destructive",
        description: (error as Error).message,
      });
    },
  });

  const handleDelete = async (id: string) => {
    deleteMutation.mutate(id);
  };

  // Only show delete button if current user created the memory
  if (!currentUser || memory?.user_id !== currentUser.uuid) {
    return null;
  }

  return (
    <Popconfirm
      title="Delete memory"
      description="Are you sure you want to delete this memory?"
      onConfirm={() => handleDelete(memory.id)}
    >
      <Button variant="ghost" size="icon" aria-label="Delete Memory" title="Delete Memory">
        <IconTrash className="al-w-4 al-h-4 al-text-red-500" />
      </Button>
    </Popconfirm>
  );
};

export default DeleteMemoryButton;
